/**
 * UNIQORNIA Support Charlotte Donation Section - v2.9 Fix custom input focus
 */

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSupportCharlotte);
  } else {
    initSupportCharlotte();
  }

  function initSupportCharlotte() {
    const section = document.querySelector('.cs-support-brutal');
    if (!section) return;

    const amountInputs = section.querySelectorAll('input[name="donation-amount"]');
    const customInput = section.querySelector('#custom-amount');
    const quantityInput = section.querySelector('#donation-quantity');
    const variantInput = section.querySelector('#selected-variant-id');
    const amountDisplay = section.querySelector('#selected-amount-display');
    const submitBtn = section.querySelector('#donate-button');

    const baseText = submitBtn.getAttribute('data-base-text') || "Support Charlotte";

    function updateState() {
      const selected = Array.from(amountInputs).find(input => input.checked);
      if (!selected) return;

      // Sync hidden variant ID field with the selected radio's data-variant-id
      if (variantInput && selected.dataset.variantId) {
        variantInput.value = selected.dataset.variantId;
      }

      const isCustom = selected.value === 'custom';

      if (isCustom) {
        const val = parseFloat(customInput.value);
        if (!isNaN(val) && val >= 1) {
          quantityInput.value = val;
          submitBtn.innerHTML = `${baseText} €${val} 💜`;
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        } else {
          quantityInput.value = 1;
          submitBtn.innerHTML = `${baseText} ... 💜`;
          submitBtn.disabled = true;
          submitBtn.style.opacity = '0.6';
        }
      } else {
        quantityInput.value = 1;
        submitBtn.innerHTML = `${baseText} €${selected.value} 💜`;
        submitBtn.disabled = false;
        submitBtn.style.opacity = '1';
        if (customInput) customInput.value = '';
      }
    }

    // Radio change listeners
    amountInputs.forEach(input => input.addEventListener('change', updateState));

    // Custom input listeners
    if (customInput) {
      customInput.addEventListener('input', updateState);
      customInput.addEventListener('keyup', updateState);

      // FIX 1: Stop mousedown from bubbling to the label on desktop
      // This prevents the browser from stealing focus away from the number field
      customInput.addEventListener('mousedown', function(e) {
        e.stopPropagation();
      });

      // FIX 2: When the input receives focus, ensure the custom radio is checked
      // and snap focus back if the radio state change caused a re-render
      customInput.addEventListener('focus', function() {
        const customRadio = section.querySelector('input[value="custom"]');
        if (customRadio && !customRadio.checked) {
          customRadio.checked = true;
          updateState();
        }
        // Defer refocus so it runs after any browser-native label handling
        setTimeout(() => customInput.focus(), 0);
      });

      // FIX 3: Same stopPropagation for mobile touch events
      // passive: true keeps scroll performance intact
      customInput.addEventListener('touchstart', function(e) {
        e.stopPropagation();
      }, { passive: true });
    }

    // Video modal
    const modalTriggers = section.querySelectorAll('[data-video-modal-trigger]');
    const modal = document.querySelector('#support-video-modal');

    if (modal) {
      const iframe = modal.querySelector('.uniq-video-modal__iframe');
      const closeButtons = modal.querySelectorAll('[data-video-modal-close]');

      modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', function() {
          if (iframe && iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
          }
          modal.style.display = 'flex';
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', function() {
          modal.style.display = 'none';
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          if (iframe) iframe.src = '';
        });
      });

      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.style.display !== 'none') {
          modal.style.display = 'none';
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          if (iframe) iframe.src = '';
        }
      });
    }

    // Initial state
    updateState();
  }

})();